import * as constants from './constants';
import {post} from "../../../utils/request";
import {
    USER_SMS_CODE,
    USER_FIND_PASSWORD
} from '../../../utils/api';

export const sendMessageActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_SMS_CODE, params);
        return result;
    }
}

export const userFindPassword = (params) => {
    return async (dispatch) => {
        const result = await post(USER_FIND_PASSWORD, params);
        return result;
    }
}

